
import React from 'react';

const Lock = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
      <g id="Group_1588" data-name="Group 1588" transform="translate(-177 -23)">
        <circle id="Ellipse_308" data-name="Ellipse 308" cx="12" cy="12" r="12" transform="translate(177 23)" fill="#6c757d" />
        <path id="ic_lock_24px" d="M14.667,6.333H13.9V4.81a3.81,3.81,0,1,0-7.619,0V6.333H5.524A1.528,1.528,0,0,0,4,7.857v7.619A1.528,1.528,0,0,0,5.524,17h9.143a1.528,1.528,0,0,0,1.524-1.524V7.857A1.528,1.528,0,0,0,14.667,6.333ZM10.1,13.19a1.524,1.524,0,1,1,1.524-1.524A1.528,1.528,0,0,1,10.1,13.19Zm2.362-6.857H7.733V4.81a2.362,2.362,0,0,1,4.724,0Z" transform="translate(178.905 25.5)" fill="#fff" />
      </g>
    </svg>
  );
};

export default Lock;